/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * ChatAgent.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiWorkspacesWorkspaceIdConversationsConversationIdMessagesParams,
  GetApiWorkspacesWorkspaceIdConversationsParams,
  MessageRequest,
  UpdateTitleRequest
} from '.././model';

import { customInstance } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getApiWorkspacesWorkspaceIdConversations = (
    workspaceId: string,
    params?: GetApiWorkspacesWorkspaceIdConversationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/conversations`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetApiWorkspacesWorkspaceIdConversationsQueryKey = (workspaceId?: string,
    params?: GetApiWorkspacesWorkspaceIdConversationsParams,) => {
    return [
    `/api/workspaces/${workspaceId}/conversations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiWorkspacesWorkspaceIdConversationsQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>, TError = unknown>(workspaceId: string,
    params?: GetApiWorkspacesWorkspaceIdConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspacesWorkspaceIdConversationsQueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>> = ({ signal }) => getApiWorkspacesWorkspaceIdConversations(workspaceId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWorkspacesWorkspaceIdConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>>
export type GetApiWorkspacesWorkspaceIdConversationsQueryError = unknown


export function useGetApiWorkspacesWorkspaceIdConversations<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>, TError = unknown>(
 workspaceId: string,
    params: undefined |  GetApiWorkspacesWorkspaceIdConversationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdConversations<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>, TError = unknown>(
 workspaceId: string,
    params?: GetApiWorkspacesWorkspaceIdConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdConversations<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>, TError = unknown>(
 workspaceId: string,
    params?: GetApiWorkspacesWorkspaceIdConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWorkspacesWorkspaceIdConversations<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>, TError = unknown>(
 workspaceId: string,
    params?: GetApiWorkspacesWorkspaceIdConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWorkspacesWorkspaceIdConversationsQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiWorkspacesWorkspaceIdConversationsUnreadSummary = (
    workspaceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/conversations/unread-summary`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApiWorkspacesWorkspaceIdConversationsUnreadSummaryQueryKey = (workspaceId?: string,) => {
    return [
    `/api/workspaces/${workspaceId}/conversations/unread-summary`
    ] as const;
    }

    
export const getGetApiWorkspacesWorkspaceIdConversationsUnreadSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>, TError = unknown>(workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspacesWorkspaceIdConversationsUnreadSummaryQueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>> = ({ signal }) => getApiWorkspacesWorkspaceIdConversationsUnreadSummary(workspaceId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWorkspacesWorkspaceIdConversationsUnreadSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>>
export type GetApiWorkspacesWorkspaceIdConversationsUnreadSummaryQueryError = unknown


export function useGetApiWorkspacesWorkspaceIdConversationsUnreadSummary<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>, TError = unknown>(
 workspaceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdConversationsUnreadSummary<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdConversationsUnreadSummary<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWorkspacesWorkspaceIdConversationsUnreadSummary<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>, TError = unknown>(
 workspaceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsUnreadSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWorkspacesWorkspaceIdConversationsUnreadSummaryQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiWorkspacesWorkspaceIdConversationsConversationId = (
    workspaceId: string,
    conversationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/conversations/${conversationId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApiWorkspacesWorkspaceIdConversationsConversationIdQueryKey = (workspaceId?: string,
    conversationId?: string,) => {
    return [
    `/api/workspaces/${workspaceId}/conversations/${conversationId}`
    ] as const;
    }

    
export const getGetApiWorkspacesWorkspaceIdConversationsConversationIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>, TError = unknown>(workspaceId: string,
    conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspacesWorkspaceIdConversationsConversationIdQueryKey(workspaceId,conversationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>> = ({ signal }) => getApiWorkspacesWorkspaceIdConversationsConversationId(workspaceId,conversationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && conversationId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWorkspacesWorkspaceIdConversationsConversationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>>
export type GetApiWorkspacesWorkspaceIdConversationsConversationIdQueryError = unknown


export function useGetApiWorkspacesWorkspaceIdConversationsConversationId<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>, TError = unknown>(
 workspaceId: string,
    conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdConversationsConversationId<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>, TError = unknown>(
 workspaceId: string,
    conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdConversationsConversationId<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>, TError = unknown>(
 workspaceId: string,
    conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWorkspacesWorkspaceIdConversationsConversationId<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>, TError = unknown>(
 workspaceId: string,
    conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWorkspacesWorkspaceIdConversationsConversationIdQueryOptions(workspaceId,conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiWorkspacesWorkspaceIdConversationsConversationIdMessages = (
    workspaceId: string,
    conversationId: string,
    params?: GetApiWorkspacesWorkspaceIdConversationsConversationIdMessagesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/conversations/${conversationId}/messages`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetApiWorkspacesWorkspaceIdConversationsConversationIdMessagesQueryKey = (workspaceId?: string,
    conversationId?: string,
    params?: GetApiWorkspacesWorkspaceIdConversationsConversationIdMessagesParams,) => {
    return [
    `/api/workspaces/${workspaceId}/conversations/${conversationId}/messages`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiWorkspacesWorkspaceIdConversationsConversationIdMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>, TError = unknown>(workspaceId: string,
    conversationId: string,
    params?: GetApiWorkspacesWorkspaceIdConversationsConversationIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspacesWorkspaceIdConversationsConversationIdMessagesQueryKey(workspaceId,conversationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>> = ({ signal }) => getApiWorkspacesWorkspaceIdConversationsConversationIdMessages(workspaceId,conversationId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && conversationId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWorkspacesWorkspaceIdConversationsConversationIdMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>>
export type GetApiWorkspacesWorkspaceIdConversationsConversationIdMessagesQueryError = unknown


export function useGetApiWorkspacesWorkspaceIdConversationsConversationIdMessages<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>, TError = unknown>(
 workspaceId: string,
    conversationId: string,
    params: undefined |  GetApiWorkspacesWorkspaceIdConversationsConversationIdMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdConversationsConversationIdMessages<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>, TError = unknown>(
 workspaceId: string,
    conversationId: string,
    params?: GetApiWorkspacesWorkspaceIdConversationsConversationIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdConversationsConversationIdMessages<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>, TError = unknown>(
 workspaceId: string,
    conversationId: string,
    params?: GetApiWorkspacesWorkspaceIdConversationsConversationIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWorkspacesWorkspaceIdConversationsConversationIdMessages<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>, TError = unknown>(
 workspaceId: string,
    conversationId: string,
    params?: GetApiWorkspacesWorkspaceIdConversationsConversationIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWorkspacesWorkspaceIdConversationsConversationIdMessagesQueryOptions(workspaceId,conversationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiWorkspacesWorkspaceIdConversationsConversationIdMessages = (
    workspaceId: string,
    conversationId: string,
    messageRequest: MessageRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/conversations/${conversationId}/messages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: messageRequest, signal
    },
      options);
    }
  


export const getPostApiWorkspacesWorkspaceIdConversationsConversationIdMessagesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>, TError,{workspaceId: string;conversationId: string;data: MessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>, TError,{workspaceId: string;conversationId: string;data: MessageRequest}, TContext> => {

const mutationKey = ['postApiWorkspacesWorkspaceIdConversationsConversationIdMessages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>, {workspaceId: string;conversationId: string;data: MessageRequest}> = (props) => {
          const {workspaceId,conversationId,data} = props ?? {};

          return  postApiWorkspacesWorkspaceIdConversationsConversationIdMessages(workspaceId,conversationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkspacesWorkspaceIdConversationsConversationIdMessagesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>>
    export type PostApiWorkspacesWorkspaceIdConversationsConversationIdMessagesMutationBody = MessageRequest
    export type PostApiWorkspacesWorkspaceIdConversationsConversationIdMessagesMutationError = unknown

    export const usePostApiWorkspacesWorkspaceIdConversationsConversationIdMessages = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>, TError,{workspaceId: string;conversationId: string;data: MessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdMessages>>,
        TError,
        {workspaceId: string;conversationId: string;data: MessageRequest},
        TContext
      > => {

      const mutationOptions = getPostApiWorkspacesWorkspaceIdConversationsConversationIdMessagesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiWorkspacesWorkspaceIdConversationsConversationIdAssign = (
    workspaceId: string,
    conversationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/conversations/${conversationId}/assign`, method: 'POST', signal
    },
      options);
    }
  


export const getPostApiWorkspacesWorkspaceIdConversationsConversationIdAssignMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdAssign>>, TError,{workspaceId: string;conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdAssign>>, TError,{workspaceId: string;conversationId: string}, TContext> => {

const mutationKey = ['postApiWorkspacesWorkspaceIdConversationsConversationIdAssign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdAssign>>, {workspaceId: string;conversationId: string}> = (props) => {
          const {workspaceId,conversationId} = props ?? {};

          return  postApiWorkspacesWorkspaceIdConversationsConversationIdAssign(workspaceId,conversationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkspacesWorkspaceIdConversationsConversationIdAssignMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdAssign>>>
    
    export type PostApiWorkspacesWorkspaceIdConversationsConversationIdAssignMutationError = unknown

    export const usePostApiWorkspacesWorkspaceIdConversationsConversationIdAssign = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdAssign>>, TError,{workspaceId: string;conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdAssign>>,
        TError,
        {workspaceId: string;conversationId: string},
        TContext
      > => {

      const mutationOptions = getPostApiWorkspacesWorkspaceIdConversationsConversationIdAssignMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiWorkspacesWorkspaceIdConversationsConversationIdClose = (
    workspaceId: string,
    conversationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/conversations/${conversationId}/close`, method: 'POST', signal
    },
      options);
    }
  


export const getPostApiWorkspacesWorkspaceIdConversationsConversationIdCloseMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdClose>>, TError,{workspaceId: string;conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdClose>>, TError,{workspaceId: string;conversationId: string}, TContext> => {

const mutationKey = ['postApiWorkspacesWorkspaceIdConversationsConversationIdClose'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdClose>>, {workspaceId: string;conversationId: string}> = (props) => {
          const {workspaceId,conversationId} = props ?? {};

          return  postApiWorkspacesWorkspaceIdConversationsConversationIdClose(workspaceId,conversationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkspacesWorkspaceIdConversationsConversationIdCloseMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdClose>>>
    
    export type PostApiWorkspacesWorkspaceIdConversationsConversationIdCloseMutationError = unknown

    export const usePostApiWorkspacesWorkspaceIdConversationsConversationIdClose = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdClose>>, TError,{workspaceId: string;conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdClose>>,
        TError,
        {workspaceId: string;conversationId: string},
        TContext
      > => {

      const mutationOptions = getPostApiWorkspacesWorkspaceIdConversationsConversationIdCloseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiWorkspacesWorkspaceIdConversationsConversationIdRead = (
    workspaceId: string,
    conversationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/conversations/${conversationId}/read`, method: 'POST', signal
    },
      options);
    }
  


export const getPostApiWorkspacesWorkspaceIdConversationsConversationIdReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdRead>>, TError,{workspaceId: string;conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdRead>>, TError,{workspaceId: string;conversationId: string}, TContext> => {

const mutationKey = ['postApiWorkspacesWorkspaceIdConversationsConversationIdRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdRead>>, {workspaceId: string;conversationId: string}> = (props) => {
          const {workspaceId,conversationId} = props ?? {};

          return  postApiWorkspacesWorkspaceIdConversationsConversationIdRead(workspaceId,conversationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiWorkspacesWorkspaceIdConversationsConversationIdReadMutationResult = NonNullable<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdRead>>>
    
    export type PostApiWorkspacesWorkspaceIdConversationsConversationIdReadMutationError = unknown

    export const usePostApiWorkspacesWorkspaceIdConversationsConversationIdRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdRead>>, TError,{workspaceId: string;conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiWorkspacesWorkspaceIdConversationsConversationIdRead>>,
        TError,
        {workspaceId: string;conversationId: string},
        TContext
      > => {

      const mutationOptions = getPostApiWorkspacesWorkspaceIdConversationsConversationIdReadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer = (
    workspaceId: string,
    conversationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/conversations/${conversationId}/customer`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApiWorkspacesWorkspaceIdConversationsConversationIdCustomerQueryKey = (workspaceId?: string,
    conversationId?: string,) => {
    return [
    `/api/workspaces/${workspaceId}/conversations/${conversationId}/customer`
    ] as const;
    }

    
export const getGetApiWorkspacesWorkspaceIdConversationsConversationIdCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>, TError = unknown>(workspaceId: string,
    conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWorkspacesWorkspaceIdConversationsConversationIdCustomerQueryKey(workspaceId,conversationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>> = ({ signal }) => getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer(workspaceId,conversationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && conversationId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApiWorkspacesWorkspaceIdConversationsConversationIdCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>>
export type GetApiWorkspacesWorkspaceIdConversationsConversationIdCustomerQueryError = unknown


export function useGetApiWorkspacesWorkspaceIdConversationsConversationIdCustomer<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>, TError = unknown>(
 workspaceId: string,
    conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdConversationsConversationIdCustomer<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>, TError = unknown>(
 workspaceId: string,
    conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>,
          TError,
          Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApiWorkspacesWorkspaceIdConversationsConversationIdCustomer<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>, TError = unknown>(
 workspaceId: string,
    conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetApiWorkspacesWorkspaceIdConversationsConversationIdCustomer<TData = Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>, TError = unknown>(
 workspaceId: string,
    conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApiWorkspacesWorkspaceIdConversationsConversationIdCustomerQueryOptions(workspaceId,conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const deleteApiWorkspacesWorkspaceIdConversationsConversationIdCustomer = (
    workspaceId: string,
    conversationId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/conversations/${conversationId}/customer`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteApiWorkspacesWorkspaceIdConversationsConversationIdCustomerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>, TError,{workspaceId: string;conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>, TError,{workspaceId: string;conversationId: string}, TContext> => {

const mutationKey = ['deleteApiWorkspacesWorkspaceIdConversationsConversationIdCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>, {workspaceId: string;conversationId: string}> = (props) => {
          const {workspaceId,conversationId} = props ?? {};

          return  deleteApiWorkspacesWorkspaceIdConversationsConversationIdCustomer(workspaceId,conversationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiWorkspacesWorkspaceIdConversationsConversationIdCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>>
    
    export type DeleteApiWorkspacesWorkspaceIdConversationsConversationIdCustomerMutationError = unknown

    export const useDeleteApiWorkspacesWorkspaceIdConversationsConversationIdCustomer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>, TError,{workspaceId: string;conversationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiWorkspacesWorkspaceIdConversationsConversationIdCustomer>>,
        TError,
        {workspaceId: string;conversationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiWorkspacesWorkspaceIdConversationsConversationIdCustomerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putApiWorkspacesWorkspaceIdConversationsConversationIdCustomerCustomerId = (
    workspaceId: string,
    conversationId: string,
    customerId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/conversations/${conversationId}/customer/${customerId}`, method: 'PUT'
    },
      options);
    }
  


export const getPutApiWorkspacesWorkspaceIdConversationsConversationIdCustomerCustomerIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdConversationsConversationIdCustomerCustomerId>>, TError,{workspaceId: string;conversationId: string;customerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdConversationsConversationIdCustomerCustomerId>>, TError,{workspaceId: string;conversationId: string;customerId: string}, TContext> => {

const mutationKey = ['putApiWorkspacesWorkspaceIdConversationsConversationIdCustomerCustomerId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdConversationsConversationIdCustomerCustomerId>>, {workspaceId: string;conversationId: string;customerId: string}> = (props) => {
          const {workspaceId,conversationId,customerId} = props ?? {};

          return  putApiWorkspacesWorkspaceIdConversationsConversationIdCustomerCustomerId(workspaceId,conversationId,customerId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiWorkspacesWorkspaceIdConversationsConversationIdCustomerCustomerIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdConversationsConversationIdCustomerCustomerId>>>
    
    export type PutApiWorkspacesWorkspaceIdConversationsConversationIdCustomerCustomerIdMutationError = unknown

    export const usePutApiWorkspacesWorkspaceIdConversationsConversationIdCustomerCustomerId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdConversationsConversationIdCustomerCustomerId>>, TError,{workspaceId: string;conversationId: string;customerId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdConversationsConversationIdCustomerCustomerId>>,
        TError,
        {workspaceId: string;conversationId: string;customerId: string},
        TContext
      > => {

      const mutationOptions = getPutApiWorkspacesWorkspaceIdConversationsConversationIdCustomerCustomerIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putApiWorkspacesWorkspaceIdConversationsConversationIdTitle = (
    workspaceId: string,
    conversationId: string,
    updateTitleRequest: UpdateTitleRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/workspaces/${workspaceId}/conversations/${conversationId}/title`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTitleRequest
    },
      options);
    }
  


export const getPutApiWorkspacesWorkspaceIdConversationsConversationIdTitleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdConversationsConversationIdTitle>>, TError,{workspaceId: string;conversationId: string;data: UpdateTitleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdConversationsConversationIdTitle>>, TError,{workspaceId: string;conversationId: string;data: UpdateTitleRequest}, TContext> => {

const mutationKey = ['putApiWorkspacesWorkspaceIdConversationsConversationIdTitle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdConversationsConversationIdTitle>>, {workspaceId: string;conversationId: string;data: UpdateTitleRequest}> = (props) => {
          const {workspaceId,conversationId,data} = props ?? {};

          return  putApiWorkspacesWorkspaceIdConversationsConversationIdTitle(workspaceId,conversationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiWorkspacesWorkspaceIdConversationsConversationIdTitleMutationResult = NonNullable<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdConversationsConversationIdTitle>>>
    export type PutApiWorkspacesWorkspaceIdConversationsConversationIdTitleMutationBody = UpdateTitleRequest
    export type PutApiWorkspacesWorkspaceIdConversationsConversationIdTitleMutationError = unknown

    export const usePutApiWorkspacesWorkspaceIdConversationsConversationIdTitle = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdConversationsConversationIdTitle>>, TError,{workspaceId: string;conversationId: string;data: UpdateTitleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiWorkspacesWorkspaceIdConversationsConversationIdTitle>>,
        TError,
        {workspaceId: string;conversationId: string;data: UpdateTitleRequest},
        TContext
      > => {

      const mutationOptions = getPutApiWorkspacesWorkspaceIdConversationsConversationIdTitleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    